import { createContext } from 'react';

const webcastingContext = createContext();

export default webcastingContext;
